module.exports = __webpack_public_path__ + "static/img/dance.902c642.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navAssistant/dance.gif
// module id = qTnQ
// module chunks = 66